// HelpLink.js
// タイトルロゴの右に配置する「使い方」リンク。
// 広い画面ではカプセル型ボタンで「使い方 / How to use」、狭い画面では丸い「?」アイコンを表示する。
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Translator, resources } from './Translator';
import './css/HelpLink.css';

const translator = new Translator(resources);

const HelpLink = ({ left = 0, top = 0, narrowBreakpoint = 480 }) => {
	const navigate = useNavigate();
	const [isNarrow, setIsNarrow] = useState(() => typeof window !== 'undefined' && window.innerWidth <= narrowBreakpoint);

	useEffect(() => {
		const onResize = () => setIsNarrow(window.innerWidth <= narrowBreakpoint);
		window.addEventListener('resize', onResize);
		return () => window.removeEventListener('resize', onResize);
	}, [narrowBreakpoint]);

	const label = translator.t('HowToUse');
	const onClick = (e) => { e.preventDefault(); navigate('/help'); };
	const style = { left: typeof left === 'number' ? `${left}px` : left, top: typeof top === 'number' ? `${top}px` : top };

	if (isNarrow) {
		return (
			<button
				className="help-link-icon"
				onClick={onClick}
				title={label}
				aria-label={label}
				style={style}
			>?</button>
		);
	}
	return (
		<button
			className="help-link-capsule"
			onClick={onClick}
			title={label}
			aria-label={label}
			style={style}
		>{label}</button>
	);
};

export default HelpLink;
